import { render, staticRenderFns } from "./matter-totals.vue?vue&type=template&id=1a0c3999&scoped=true&"
import script from "./matter-totals.vue?vue&type=script&lang=ts&"
export * from "./matter-totals.vue?vue&type=script&lang=ts&"
import style0 from "./matter-totals.vue?vue&type=style&index=0&id=1a0c3999&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c3999",
  null
  
)

export default component.exports